module.exports = __webpack_public_path__ + "img/img53.cc5f8950.png";